<template>
  <div class="tags-page">
    <div class="container">
      <div class="tags-page__header">
        <router-link :to="{ name: 'activity-library-homepage' }" class="d-block tags-page__back-to-activities fs-14"> <img src="static/img/activity-configurator/arrow-left.svg" alt /> Back to Activities </router-link>

        <div class="d-flex justify-content-between align-items-center mt-15">
          <div class="col-md-6">
            <span class="manage-tags-text d-block mb-5">Manage Tags</span>
            <span class="manage-tags-description">Add and edit tags that can be applied to activities for custom categorization.</span>
          </div>
          <button class="tags-page__header__add-tag-btn btn" @click="onClickAddTags">
            <i class="fa fa-plus-square fs-26 mr-5"></i>
            <span class="tag-span">Add Tags</span>
          </button>
        </div>
      </div>

      <ManageTagsTable v-if="tags" :tags="tags.rows" :count="tags.count" @editTag="onEditTag" @deleteTag="onDeleteTag" @onSortColumn="onSortColumn" @onPageChange="onPageChange" :pagination="pagination" />
    </div>
    <div class="tags-page">
      <b-modal ref="addTagModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="add-tag-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true">
        <div class="add-tag-modal__container pl-20 pr-65 pt-25 pb-25">
          <img src="static/img/add.svg" class="rt-2-10 add-tag-modal__close-icon" @click="closeModal" />
          <div class="row">
            <div class="col-4 pr-0">
              <span class="fs-11 fw-bold color-black">Tag Name</span>
            </div>
            <div class="col-8 pl-0">
              <span class="fs-11 fw-bold color-black">Tag Description</span>
            </div>
          </div>

          <b-form>
            <div class="row mt-8" v-for="(field, index) in tagsFormFields" :key="index">
              <div class="col-4 pr-0">
                <b-form-input type="text" @input="resetAutoSave" name="tagname" v-model="field.name" class="add-tag-modal__name-input" v-validate="'required'" :state="veeFields.tagname && veeFields.tagname.dirty ? !errors.has('tagname') : null" placeholder="Enter tag name" />
              </div>
              <div class="col-7 pl-0">
                <b-form-input type="text" @input="resetAutoSave" name="tagdesc" v-model="field.desc" class="add-tag-modal__desc-input" v-validate="'required'" :state="veeFields.tagdesc && veeFields.tagdesc.dirty ? !errors.has('tagdesc') : null" placeholder="Enter tag description" />
              </div>
              <template v-if="index != 0">
                <div class="col-1 pt-2" @click="onRemoveEmptyTagField(index)">
                  <img src="static/img/activity-configurator/delete-tag.svg" class="remove-form-icon" />
                </div>
              </template>
            </div>
          </b-form>

          <div class="row mt-7" v-if="isCreateTag">
            <div class="col-12">
              <span class="add-tag-modal__add-another-tag" @click="addAnotherTag">Add another tag</span>
            </div>
          </div>

          <div class="row mt-14">
            <div class="col-12">
              <button class="primary add-tag-modal__save-tag-btn btn fs-14" v-if="isCreateTag" @click="postNewTags(false)">
                Save Tags
              </button>
              <button class="primary add-tag-modal__save-tag-btn btn fs-14" v-else @click="editTag(false)">
                Save Tags
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ManageTagsTable from "@/components/activity-library/manage-tags-table";
import swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "ActivityConfiguratorManageTagspage",
  components: {
    ManageTagsTable
  },
  data() {
    return {
      tags: null,
      tagFormField: { name: "", desc: "" },
      tagsFormFields: [{ name: "", desc: "" }],
      // When the modal opens, we need to know if the modal is opened for creating or editing
      isCreateTag: true,
      selectedTag: null,
      errorMsg: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sortOrder: "ASC",
        sortValue: "name",
        search: ""
      },
      pagination: {
        current: 1,
        total: 1
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  mounted() {
    this.startAutoSave();
  },
  computed: {
    areFieldsValid() {
      return this.tagsFormFields.every(field => field.name && field.desc);
    }
  },
  methods: {
    onClickAddTags() {
      this.$refs.addTagModal.show();
    },
    tagSearchFun() {
      const search = $("#tagValue").val();
      this.tagSearch = search;
      this.queryParams = {
        ...this.queryParams,
        search: search
      };
      this.getTagsList();
    },
    addAnotherTag() {
      this.tagsFormFields.push({ ...this.tagFormField });
    },

    resetModal() {
      this.tagsFormFields = [{ ...this.tagFormField }];
      this.isCreateTag = true;
      this.selectedTag = null;
    },

    onModalClose() {
      this.resetModal();
    },

    onEditTag(tag) {
      this.selectedTag = tag;
      this.tagsFormFields = [{ name: tag.name, desc: tag.desc }];
      this.isCreateTag = false;
      this.$refs.addTagModal.show();
    },

    onSortColumn({ column, order }) {
      const sortValue = column.name;
      this.pagination.current = 1;
      this.queryParams = {
        ...this.queryParams,
        sortValue,
        sortOrder: order,
        pageNum: this.pagination.current
      };
      this.getTagsList();
    },

    closeModal() {
      this.$refs.addTagModal.hide();
    },

    onRemoveEmptyTagField(index) {
      this.tagsFormFields.splice(index, 1);
    },
    getTagsList() {
      this.queryParams.pageNum = this.pagination.current - 1;
      this.$api
        .getActivityTags(this.queryParams)
        .then(response => {
          this.tags = response.data.result;
          this.pagination.total = Math.floor(this.tags.count / this.queryParams.pageSize) + 1;
        })
        .catch(() => {
          this.$toastr.error("Error while getting tags list");
        });
    },
    validateTags(tagFormFields, autoSave = false) {
      let isNameValid = true;
      let isDescValid = true;
      for (let i = 0; i < tagFormFields.length; i++) {
        const field = tagFormFields[i];
        if (!field.name || field.name.trim().length == 0) {
          isNameValid = false;
          if (!autoSave) {
            this.errorMsg = "Name is required.";
          }
          break;
        }
        if (!field.desc || field.desc.trim().length == 0) {
          isDescValid = false;
          if (!autoSave) {
            this.errorMsg = "Description is required.";
          }
          break;
        }
      }
      if (isNameValid && isDescValid) {
        if (!autoSave) {
          this.errorMsg = "";
        }
        return true;
      }
      return false;
    },
    postNewTags(autoSave = false) {
      const isValid = this.validateTags(this.tagsFormFields, autoSave);
      if (isValid) {
        this.$api
          .createActivtyTags(this.tagsFormFields)
          .then(response => {
            if (response.data.result instanceof Array) {
              const message = response.data.result.join("</br>");
              if (!autoSave) {
                this.$toastr.error(message);
              }
            } else {
              if (!autoSave) {
                this.$toastr.success("Tags created successfully");
              }
              this.$refs.addTagModal.hide();
              this.getTagsList();
            }
          })
          .catch(() => {
            if (!autoSave) {
              this.$toastr.error("Unable to create new tags");
            }
          });
      } else {
        if (!autoSave) {
          this.$toastr.error(this.errorMsg);
        }
      }
    },
    editTag(autoSave = false) {
      const isValid = this.validateTags(this.tagsFormFields, autoSave);
      if (isValid) {
        const tagId = this.selectedTag.id;
        this.$api
          .modifyActivityTag(tagId, this.tagsFormFields[0])
          .then(() => {
            if (!autoSave) {
              this.$toastr.success("Tag updated successfully");
            }
            this.$refs.addTagModal.hide();
            this.getTagsList();
          })
          .catch(error => {
            if (error.data.result) {
              if (!autoSave) {
                this.$toastr.error(error.data.result);
              }
            } else {
              if (!autoSave) {
                this.$toastr.error("Unable to modify tag");
              }
            }
          });
      } else {
        if (!autoSave) {
          this.$toastr.error(this.errorMsg);
        }
      }
    },
    onDeleteTag(tag) {
      const isTagAssociatedWithAnActivity = tag.activity_count && tag.activity_count > 0;
      let warningText = "";
      if (isTagAssociatedWithAnActivity) {
        warningText = "This tag is currently associated with existing activities. Are you sure you want to remove this tag and any associations?";
      } else {
        warningText = "Are you sure you want to delete this tag?";
      }
      swal({
        title: warningText,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .deleteActivityTag(tag.id)
            .then(() => {
              this.$toastr.success("Tag deleted successfully");
              this.getTagsList();
            })
            .catch(() => {
              this.$toastr.error("Unable to delete the tag");
            });
        }
      });
    },

    onPageChange(direction) {
      if (this.pagination.current === 1 && direction === -1) {
        return;
      }

      if (this.pagination.current === this.pagination.total && direction === 1) {
        return;
      }

      this.pagination.current += direction;

      this.getTagsList();
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.isCreateTag ? this.postNewTags(true) : this.editTag(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.stopAutoSave();
      this.startAutoSave();
    }
  },
  beforeDestroy() {
    this.stopAutoSave();
  },
  created() {
    this.getTagsList();
  }
};
</script>

<style scoped lang="scss">
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
      padding: 3px 5px;
    }
  }

  .manage-tags-text {
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: auto;
      border-radius: 4px;
      background-color: #ffffff;
      overflow: auto;
      position: relative;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 100%;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }

    &__close-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
}
.tag-span {
  position: relative;
  top: -5px;
}
.modal-dialog {
  max-height: auto !important;
}
.remove-form-icon {
  cursor: pointer;
  height: 28px;
}
.dataTables_search input {
  width: 96%;
  height: 36px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
}
#datatable_filter.dataTables_search {
  position: relative;
  left: 43%;
}
</style>
